import angular from 'angular'

angular.module("core.application.main").directive("core.application.main.directive.greaterThan", function() {

    var expose = {};
    expose.require = "ngModel";
    expose.restrict = "A";

    expose.link = function($scope, element, attributes, controller) {

        var validate = function(value) {
            var greaterThan;
            if ((value || value === 0) && (attributes.greaterThan || attributes.greaterThan === 0)) {
                greaterThan = parseFloat(value) > parseFloat(attributes.greaterThan);
            } else { // ignore the greaterThan check if either of the values is not provided
                greaterThan = true;
            }
            controller.$setValidity("greaterThan", greaterThan);
            return value;
        };

        attributes.$observe("greaterThan", function() {
            validate(controller.$viewValue);
        });
        controller.$parsers.unshift(validate);
        controller.$formatters.unshift(validate);

    };

    return expose;
});
